/**
 * Micro-interação de emoji voando pro carrinho no clique de Adicionar ao carrinho.
 * Puramente decorativo — não interfere no fluxo real de AJAX do product-form.
 */
(function () {
  var FLY_DURATION = 900;
  var ARC_HEIGHT = 140;
  var DEFAULT_EMOJI = '🍏';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getCenter(el) {
    var rect = el.getBoundingClientRect();
    return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
  }

  function getFlyEmoji() {
    return (document.body && document.body.dataset.atcFlyEmoji) || DEFAULT_EMOJI;
  }

  function getFlyIcon() {
    return (document.body && document.body.dataset.atcFlyIcon) || '';
  }

  function pulseCartIcon() {
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;

    cartIcon.classList.remove('atc-cart-pulse');
    void cartIcon.offsetWidth;
    cartIcon.classList.add('atc-cart-pulse');
    cartIcon.addEventListener(
      'animationend',
      function () {
        cartIcon.classList.remove('atc-cart-pulse');
      },
      { once: true }
    );
  }

  function flyToCart(button) {
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;

    var start = getCenter(button);
    var end = getCenter(cartIcon);
    var dx = end.x - start.x;
    var dy = end.y - start.y;
    var quarterX = dx * 0.25;
    var quarterY = dy * 0.15 - ARC_HEIGHT * 0.85;
    var midX = dx * 0.55;
    var midY = dy * 0.4 - ARC_HEIGHT;
    var lateX = dx * 0.85;
    var lateY = dy * 0.8 - ARC_HEIGHT * 0.35;

    var fly = document.createElement('span');
    fly.className = 'atc-fly-emoji';
    fly.setAttribute('aria-hidden', 'true');
    var iconUrl = getFlyIcon();
    if (iconUrl) {
      fly.classList.add('atc-fly-emoji--icon');
      var img = document.createElement('img');
      img.src = iconUrl;
      img.alt = '';
      img.width = 48;
      img.height = 48;
      fly.appendChild(img);
    } else {
      fly.textContent = getFlyEmoji();
    }
    fly.style.left = start.x + 'px';
    fly.style.top = start.y + 'px';
    document.body.appendChild(fly);

    var animation = fly.animate(
      [
        { transform: 'translate(-50%, -50%) translate(0px, 0px) rotate(0deg) scale(0.6)', opacity: 0, offset: 0 },
        {
          transform: 'translate(-50%, -50%) translate(0px, -12px) rotate(-6deg) scale(1.25)',
          opacity: 1,
          offset: 0.12,
        },
        {
          transform:
            'translate(-50%, -50%) translate(' + quarterX + 'px, ' + quarterY + 'px) rotate(6deg) scale(1.1)',
          opacity: 1,
          offset: 0.35,
        },
        {
          transform: 'translate(-50%, -50%) translate(' + midX + 'px, ' + midY + 'px) rotate(-8deg) scale(1)',
          opacity: 1,
          offset: 0.6,
        },
        {
          transform: 'translate(-50%, -50%) translate(' + lateX + 'px, ' + lateY + 'px) rotate(10deg) scale(0.6)',
          opacity: 0.9,
          offset: 0.85,
        },
        {
          transform: 'translate(-50%, -50%) translate(' + dx + 'px, ' + dy + 'px) rotate(0deg) scale(0.2)',
          opacity: 0,
          offset: 1,
        },
      ],
      { duration: FLY_DURATION, easing: 'cubic-bezier(.22, .61, .36, 1)' }
    );

    animation.onfinish = function () {
      fly.remove();
      pulseCartIcon();
    };
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('product-form .product-form__submit[type="submit"]');
    if (!button) return;
    if (button.hasAttribute('disabled') || button.getAttribute('aria-disabled') === 'true') return;
    if (prefersReducedMotion()) return;

    flyToCart(button);
  });
})();
